import Tdg_CompanyDetailModelBase from '../_generated/modelBases/tdg-company-detail-model-base';

export default class Tdg_CompanyDetailModel extends Tdg_CompanyDetailModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
